import { FileText, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { ExistingFile } from "../types";

interface FileListProps {
  files: ExistingFile[];
  onDeleteFile?: (fileId: string) => Promise<void>;
  isDeletingFile: string | null;
  isLoading?: boolean;
}

export const FileList = ({ 
  files, 
  onDeleteFile, 
  isDeletingFile,
  isLoading = false 
}: FileListProps) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-4">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span className="ml-2">Loading files...</span>
      </div>
    );
  }

  if (files.length === 0) {
    return (
      <div className="text-sm text-muted-foreground p-2">
        No files uploaded yet
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {files.map((file) => (
        <div
          key={file.id}
          className="flex items-center justify-between p-2 border rounded-md bg-muted/30"
        >
          <div className="flex items-center space-x-2">
            <FileText className="h-4 w-4 text-muted-foreground" />
            <span className="text-sm truncate">{file.file_name}</span>
            <span className="text-xs text-muted-foreground">
              ({Math.round(file.file_size / 1024)}KB)
            </span>
            {file.status !== 'completed' && (
              <span className="text-xs text-yellow-500">
                ({file.status})
              </span>
            )}
          </div>
          {onDeleteFile && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => onDeleteFile(file.id)}
              disabled={isDeletingFile === file.id}
            >
              {isDeletingFile === file.id ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <X className="h-4 w-4" />
              )}
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};